/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import State from './State';
import {Button, FormGroup as BootstrapFormGroup, FormText, Modal} from 'react-bootstrap';
import styles from './styles';
import {css} from 'aphrodite';

// eslint-disable-next-line @typescript-eslint/ban-types
class MessageWithModal extends React.Component<{}, State> {

	constructor(props = {}) {
		super(props);
		this.state = {showModal: false};
	}

	handleCloseModal = (): void => {
		this.setState({showModal: false});
	};

	handleShowModal = (): void => {
		this.setState({showModal: true});
	};

	render(): ReactNode {
		const state: Readonly<State> = this.state;

		return (
			<React.Fragment>
				<BootstrapFormGroup controlId="message">
					<FormText as="div">
						{'Wij gaan je account omzetten naar een nieuwe versie. Deze versie bevat '}
						<Button
							type="button"
							className={css(styles.modalButton)}
							variant="link"
							onClick={this.handleShowModal}>
							{'two-factor authenticatie'}
						</Button>
						{'. Ter controle willen wij jouw telefoonnummer verifiëren.'}
					</FormText>
				</BootstrapFormGroup>
				<Modal show={state.showModal} onHide={this.handleCloseModal}>
					<Modal.Header closeButton>
						<Modal.Title>{'Wat is two-factor authentication?'}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>
							{'Een two-factor authentication (2FA) is een methode waarbij je twee stappen succesvol moet doorlopen om ' +
							'ergens toegang tot te krijgen. In het Nederlands noemen we dit ook wel een twee stappen authenticatie.'}
						</p>
						<p>
							{'De eerste stap is het invoeren van een gebruikersnaam en wachtwoord. De tweede stap is het invoeren van ' +
							'een (sms)code. Deze methode is een stuk veiliger omdat er alleen toegang tot het account wordt verkregen ' +
							'indien de login gegevens bekend zijn en er op dat moment beschikking is over het telefoonnummer.'}
						</p>
					</Modal.Body>
				</Modal>
			</React.Fragment>
		);
	}
}

export default MessageWithModal;
